import { useState } from 'react'

import { Item } from '../../models/Item'
import { Option } from '../../models/Option'
import Label from '../app/design/Label'
import { Chip } from '../common/fields/Chip'
import { AddressPicker } from '../common/AddressPicker'

const LocationOptions = [
    new Option(undefined, { id: 'none', label: 'No location' }),
    new Option(undefined, { id: 'business', label: 'Business location' }),
    new Option(undefined, { id: 'client', label: 'Client selects location' }),
    new Option(undefined, { id: 'another', label: 'Another location' }),
]

type Props = {
    item: Item
    onUpdateItem: (item: Item) => void
}

export const ItemLocationChips = ({ onUpdateItem, item }: Props) => {
    const [selectedOptionId, setSelectedOptionId] = useState<string | undefined>(() => {
        if (item.isVirtual) return 'none'
        if (item.location) return 'another'
        if (item.clientSelectsLocation) return 'client'
        return 'business'
    })

    return (
        <div className="flex flex-col gap-y-8">
            <div className="flex flex-wrap gap-x-2">
                {LocationOptions.map((option) => (
                    <Chip
                        size="small"
                        key={option.id}
                        title={option.label ?? ''}
                        isSelected={option.id === selectedOptionId}
                        onClick={() => {
                            setSelectedOptionId(option.id)
                            if (option.id !== 'another') {
                                onUpdateItem(
                                    item.clone({
                                        location: undefined,
                                        is_virtual: option.id === 'none',
                                        client_selects_location: option.id === 'client',
                                    })
                                )
                            }
                        }}
                    />
                ))}
            </div>
            {selectedOptionId === 'another' && (
                <div className="flex flex-col gap-y-3">
                    <Label>Another location</Label>
                    <AddressPicker
                        placeholder="Enter another location"
                        size="medium"
                        onSelect={(address) => {
                            onUpdateItem(
                                item.clone({
                                    location: address,
                                    is_virtual: false,
                                    client_selects_location: false,
                                })
                            )
                        }}
                    />
                </div>
            )}
        </div>
    )
}
